import { Box } from '@chakra-ui/react'
import { QuestionSectionProps } from '../utils/types'

export const QuestionSection = ({ Component }: QuestionSectionProps) => {
  return (
    <>
      <Box mb={4} />
      <Component />
    </>
  )
}
